import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getWorkingGroup = (id) => {
  const url = `${API_ROOT}/proposal/${id}/working-group`
  return doGet(url)
}

export const saveWorkingGroup = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/working-group`
  return doPost(url, request)
}

export const getWorkingGroupById = (id, request, workingId) => {
  const url = `${API_ROOT}/proposal/${id}/working-group/${workingId}`
  return doGet(url, request)
}

export const updateWorkingGroup = (id, request, workingId) => {
  const url = `${API_ROOT}/proposal/${id}/working-group/${workingId}`
  return doPut(url, request)
}

export const deleteWorkingGroup = (id, workingId) => {
  const url = `${API_ROOT}/proposal/${id}/working-group/${workingId}`
  return doDelete(url)
}
